import { render, staticRenderFns } from "./ContractTransactions.vue?vue&type=template&id=6d23b249"
import script from "./ContractTransactions.vue?vue&type=script&lang=js"
export * from "./ContractTransactions.vue?vue&type=script&lang=js"
import style0 from "./ContractTransactions.vue?vue&type=style&index=0&id=6d23b249&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports